import React from 'react';
import { Card } from 'react-bootstrap';
import '../../scss/news-styling-component/news-card.style.scss';
import { Calendar, GreyTimer, HollowStar, RightArrow, Share } from '../images/svg/icons';
import { useTranslation } from 'react-i18next';

interface NewsCardProps {
  image: string;
  title: string;
  date: string;
  description: string;
  tag?: string;
  link: string;
  readTime?: string;
  pressRelease?: boolean;
}

export const NewsCard: React.FC<NewsCardProps> = ({
  image,
  title,
  date,
  description,
  tag,
  link,
  readTime = '',
  pressRelease,
}) => {
    const { t } = useTranslation();
  return (
    <Card className="news-card">
      <div className="news-card-image-wrapper">
        <Card.Img
          variant="top"
          src={image}
          className="news-card-image"
          alt={title}
        />
        {tag && <span className="news-card-tag">{t(tag)}</span>}
      </div>
      <Card.Body className="news-card-content">
        <div className="news-card-meta">
          <span className="news-card-meta-item">
            <img src={Calendar} alt={t("ALT_CALENDAR")} className="news-card-icon" />
            <span>{date}</span>
          </span>
          <span className="news-card-meta-item">
            <img src={GreyTimer} alt={t("ALT_TIME")} className="news-card-icon" />
            <span>{readTime}</span>
          </span>
          {pressRelease && (
            <span className="news-card-meta-item">
              <img src={HollowStar} alt={t("ALT_PRESS")} className="news-card-icon" />
              <span>{t("PRESS_RELEASES")}</span>
            </span>
          )}
        </div>
        <Card.Title className="news-card-title">{title}</Card.Title>
        <Card.Text className="news-card-description">{description}</Card.Text>
        <div className="news-card-footer">
          <a href={link} className="news-card-link">
            {t("READ_NEWS")}
            <img src={RightArrow} alt={t("ALT_ARROW")} className="news-card-icon" />
          </a>
          <button className="news-card-share">
            {t("SHARE")}
            <img src={Share} alt={t("SHARE")} className="news-card-icon" />
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};
